module.exports = __webpack_public_path__ + "static/media/jupiter-2.473f8ffc.jpg";